import { fetchMutation } from "../../actions";
import { ShowAlert } from "../../common/alert";
import { errorToDisplay } from "../../helper/CommonFuncs";
import { INVITE_PATIENT } from "../../viewpages/newpages/InvitePatientModdule/invitePatientAction";

export const filterNumber = (input) => {
   if (!input) return "";
   let filteredNumber = input.replace(/[^0-9+]/g, "");
   if (!filteredNumber.startsWith("+1")) {
      filteredNumber = `+1${filteredNumber}`;
   }
   return filteredNumber;
};

export const isValidEmail = (email) => {
   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
   return emailRegex?.test(email);
};

export const invitePatient = async (
   patientDetailsEpic,
   loggedInProviderDetails,
   callback = () => { },
   errorCallback = () => { }
) => {
   let enterpriseId = loggedInProviderDetails.enterpriseInfo.id;
   let enterpriseName = loggedInProviderDetails.enterpriseInfo.name;
   const epi = patientDetailsEpic.identifier.find(entry => entry.type?.text === 'EPI')?.value;
   const mrn = patientDetailsEpic.identifier.find(entry => entry.type?.text === 'MRN')?.value;
   let payload = {
      noNotification: true,
      patient: {
         name: {
            fullName: patientDetailsEpic.name[0].text,
         },
         contactInformation: {
            email: new Date().getTime().toString() + "@playbackhealth.com",
            mobileNumber: null,
         },
         dateOfBirth: patientDetailsEpic.birthDate,
         mrn: epi || "",
         healthSystems: [
            {
               id: enterpriseId,
               name: enterpriseName,
               role: "patient",
               patientIdentifiers: [
                  {
                     type: "MRN",
                     number: mrn || "",
                     authority: "MRN",
                  },
                  {
                     type: "EPI",
                     number: epi || "",
                     authority: "EPI"
                  },
                  { type: "id", number: patientDetailsEpic.id, authority: "EPIC" },
               ],
            },
         ],
      },
   };

   fetchMutation(
      INVITE_PATIENT,
      payload,
      (data) => {
         callback(data.data.addPatient.user.id);
      },
      (error) => {
         errorCallback();
         ShowAlert(errorToDisplay(error), "error");
      }
   );
};

function getEmailAndPhone(telecom) {
   let email = null;
   let phone = null;

   for (let i = 0; i < telecom.length; i++) {
      if (telecom[i].system === "phone") {
         phone = telecom[i].value;
      } else if (telecom[i].system === "email") {
         email = telecom[i].value;
      }
   }

   return { email, phone };
}
